import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { authService } from './services/authService';
import { installSuspensionGuard } from './utils/suspensionGuard';

installSuspensionGuard(() => authService.logout());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);